import posthog from 'posthog-js';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY || 'phc_BuxHM2gEsf9hPG8T3gK8Y9sDm90IASd0AwfCM79TlW6';
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

class AnalyticsService {
  private initialized = false;

  init() {
    if (this.initialized) return;

    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      capture_pageview: true,
      capture_pageleave: true,
      autocapture: true,
      persistence: 'localStorage',
    });

    this.initialized = true;
  }

  identify(userId: string, properties?: Record<string, any>) {
    if (!this.initialized) return;
    posthog.identify(userId, properties);
  }

  reset() {
    if (!this.initialized) return;
    posthog.reset();
  }

  track(event: string, properties?: Record<string, any>) {
    if (!this.initialized) return;
    posthog.capture(event, properties);
  }

  screen(screenName: string, properties?: Record<string, any>) {
    if (!this.initialized) return;
    posthog.capture('$pageview', { $current_url: screenName, ...properties });
  }
}

const analyticsService = new AnalyticsService();
export default analyticsService;
